import { ArticleHeading1, ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NewbuildingBlackFridayTopBanner.css';

export const NewbuildingBlackFridayTopBanner: React.FC = () => {
  return (
    <div className={styles['banner']}>
      <ArticleHeading1 color="white_100">Чёрная пятница: все скидки и бонусы</ArticleHeading1>
      <ArticleParagraph1 color="white_100">Выберите квартиру и позвоните по номеру в объявлении</ArticleParagraph1>
    </div>
  );
};
